interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i> 上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-9 w-9 rounded-md text-sm font-medium transition-colors ${
            current === page
              ? 'bg-primary-600 text-background-50'
              : 'border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页 <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}